<div class="row">
    <div class="col-md-12">
        <div class="card card-accent-success">
            <div class="card-header-buscador">
                <i class="fa fa-align-justify"></i> Listado de Certificados Fitosanitarios
            </div>

            <div class="card-body-grid">

                <p-table #tableSearch autoLayout="true" [value]="result?.ResultList" [lazy]="true" [lazyLoadOnInit]="false" (onLazyLoad)="onSearchLazy($event)" [paginator]="true"
                            [columns]="cols" sortField="Codigo" [rows]="result?.PageSize" [totalRecords]="result?.TotalCount" [loading]="loading"
                            styleClass="table table-responsive-sm  table-striped table-sm" [ngClass]="displayGridHidden(result?.ResultList)" rowExpandMode="single">
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th nowrap scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                {{col.header}}
                                <p-sortIcon *ngIf="col.field!=='Link' && col.field!=='Image' && col.field!=='EstadoSolicitudExDescripcion' && col.field!=='EstadoCfDescripcion'  && col.field!=='TipoSolicitudExDescripcion'" [field]="col.field"></p-sortIcon>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
                        <tr>

                            <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                <span *ngIf="(col.field!=='Link' && col.field!=='Image' && col.field!=='Utilizado' && col.field!=='Disponible'
                                    && col.field!=='EstadoSolicitudExDescripcion' && col.field!=='EstadoCfDescripcion'  && col.field!=='TipoSolicitudExDescripcion')">{{rowData[col.field]}}</span>
                                <span *ngIf="col.field==='Utilizado'">{{rowData[col.field] | siNo}}</span>
                                <span *ngIf="col.field==='Disponible'">{{rowData[col.field] | siNo}}</span>
                                <span *ngIf="col.field==='Image'">
                                    <!--***ICONOS***-->
                                    <img class="estado-icono" src="{{ null| IconoEstadoSolicitudEx}}" container="body" ngbTooltip="{{rowData['TipoSolicitudExDescripcion']}}" />
                                    <label class="codigo-icono" container="body" ngbTooltip="{{rowData['IdTipoSolicitudEx']}}">{{rowData['CodigoTipoSolicitud'] }}</label>
                                    <img class="estado-icono" src="{{rowData['IdEstadoSolicitudEx'] | IconoEstadoSolicitudEx}}" container="body" ngbTooltip="{{rowData['EstadoSolicitudExDescripcion']}}" />
                                    <img class="estado-icono" src="{{rowData['IdEstadoCf'] | IconoEstadoCertificadoFitoEx}}" container="body" ngbTooltip="{{rowData['EstadoCfDescripcion']}}" />
                                </span>

                                <div *ngIf="col.field==='Link'" class="btn-group">

                                    <button (click)="onDownload(rowData)" type="button" title="Descargar Certificado"
                                            class="btn btn-sm btn-danger">
                                        <span class="fa fa-download"></span>
                                    </button>


                                    <button *ngIf="rowData['TipoSolicitudExDescripcion'] === 'Canarias' && isAdmin" (click)="onEdit(rowData)" type="button" ngbTooltip="Editar" placement="right"
                                            class="btn btn-sm btn-info">
                                        <span class="fa fa-edit"></span>

                                    </button>



                                </div>
                            </td>
                        </tr>

                    </ng-template>

                </p-table>
                <div *ngIf="tableSearch?.totalRecords === 1" class="p-2">Se ha encontrado {{ tableSearch?.totalRecords | number:'1.0-0':'es-ES' }} registro</div>
                <div *ngIf="tableSearch?.totalRecords > 1" class="p-2">Se han encontrado {{ tableSearch?.totalRecords | number:'1.0-0':'es-ES' }} registros</div>
                <div class="empty-grid" *ngIf="tableSearch?.totalRecords===0">No se ha encontrado ningún registro</div>
            </div>

        </div>
    </div>
</div>
